import { Page } from '@app/components/page/Page';
import { FragmentIcon } from '@app/modules/fragments/components/FragmentIcon';
import { Station } from '@mi-front/core';
import { useIntl } from 'react-intl';
import { Fragment } from '../../../types';
import { FragmentsDeleteView } from '../../delete/FragmentsDeleteView';
import { useFragmentTabs } from '../hooks/useFragmentTabs';

interface Props {
  readonly station: Station;
  readonly fragment: Fragment;
}

export function FragmentsViewHeader(p: Props) {
  const { station, fragment } = p;
  const { $t } = useIntl();
  const tabs = useFragmentTabs(station, fragment);

  return (
    <Page.Header
      title={fragment.title}
      breadcrumbs={
        <Page.Breadcrumbs
          items={[
            {
              icon: <FragmentIcon fontSize="inherit" />,
              content: $t({
                id: 'fragments.listScreen.allFragments',
                defaultMessage: 'Fragmentos',
              }),
            },
            {
              content: station.name,
              href: `/fragments/s/${station.slug}`,
            },
          ]}
        />
      }
      tabs={tabs}
      actions={<FragmentsDeleteView station={station} fragment={fragment} />}
    />
  );
}
